import {
    GET_REPORT_TYPES,
    GET_USERS,
    SET_MONTH,
    SET_YEAR,
    SET_FILTER_TYPE,
    SET_FILTER_USER_UID,
    SET_TABLE,
} from "./types";
import moment from "moment";
const year = moment().format("YYYY");
const month = moment().month();
const INITIAL_STATE = {
    reportTypes: false,
    users: false,
    monthFilter: month,
    dateFilterType: false,
    yearFilter: year,
    requesting: false,
    userUid: false,
    currentTable: "required",
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_FILTER_USER_UID: {
            return { ...state, userUid: action.payload };
        }
        case GET_REPORT_TYPES.REQUEST: {
            return { ...state, requesting: true, reportTypes: false };
        }
        case GET_REPORT_TYPES.FAIL: {
            return { ...state, requesting: false, reportTypes: false };
        }
        case GET_REPORT_TYPES.SUCCESS: {
            return { ...state, requesting: false, reportTypes: action.payload };
        }
        case GET_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case GET_USERS.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case GET_USERS.SUCCESS: {
            return { ...state, requesting: false, users: action.payload };
        }
        case SET_MONTH: {
            return { ...state, monthFilter: action.payload };
        }
        case SET_YEAR: {
            return { ...state, yearFilter: action.payload };
        }
        case SET_FILTER_TYPE: {
            return { ...state, dateFilterType: action.payload };
        }
        case SET_TABLE: {
            return {
                ...state,
                currentTable: action.payload,
            };
        }
        default: {
            return { ...state };
        }
    }
};
